import type { MouseEvent } from 'react'
import type { IButtonProps } from 'atoms/Button'

import { ButtonCorners } from 'atoms/Button'
import {
  ControlBackwardSecondaryOpacityDark,
  ControlBackwardSecondaryOpacityDarkVerticalFluid,
  InlineBackwardButton,
} from 'atoms/Button/Templates'
import { RowControlsType } from '../RowContainer.h'

type ControlProps = {
  controlsType: RowControlsType
  onClick: (event: MouseEvent) => void
  disabled?: boolean
} & Pick<IButtonProps, 'corners'>

export const PrevControl = ({
  controlsType,
  onClick,
  disabled,
  corners = ButtonCorners.CORNERS_RIGHT_25,
}: ControlProps) => {
  const controlComponents = {
    [RowControlsType.inHeader]: InlineBackwardButton,
    [RowControlsType.inRowFluid]:
      ControlBackwardSecondaryOpacityDarkVerticalFluid,
    [RowControlsType.inRow]: ControlBackwardSecondaryOpacityDark,
  }
  const Control =
    controlComponents[controlsType] ??
    ControlBackwardSecondaryOpacityDarkVerticalFluid

  return <Control onClick={onClick} disabled={disabled} corners={corners} />
}
